import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { JobType } from '../../_types';
import { UserImportResult } from 'views/App/Portal/LexID/UserImports/_types/user_import';

export default function useOrganizationUserImportResults(
  organizationId: string,
  bucketName: string,
  key: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/phoenix/job-service/v1/org/${organizationId}/jobs/job-type/${JobType.ImportUsers.toString()}/bucket/${encodeURIComponent(bucketName)}/key/${encodeURIComponent(key)}`;
  return useQuery<UserImportResult, ServerErrorResponse>(
    ['organization_user_import_results', organizationId, bucketName, key],
    async (): Promise<UserImportResult> => {
      try {
        if (!organizationId || !bucketName || !key) {
          throw new Error('Missing required parameters');
        }
        const data: UserImportResult = await fetcher({
          method: 'get',
          url,
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: false,
      enabled: !!organizationId && !!bucketName && !!key,
      ...options,
    }
  );
}
